<ng-container *ngIf="!isLoading; else loadingTemplate">
  <div [ngClass]="isMobile ? 'mobile-header' : 'header'">
    <app-external-header
      style="z-index: 1000; position: relative;"
      [isInboxPresent]="true"
      [isCompanyProfile]="true"
      [isProfile]="false"
      [isMobile]="isMobile"
      [showButtons]="false"
      [showProfilePicture]="true"
    ></app-external-header>
  </div>


  <div class="page-container mat-typography">
    <div class="content">

      <div class="sidebar">
        <!-- User Information -->
        <div class="applicant">
          <!-- User Picture and Info -->
          <div class="profile-picture-wrapper" [ngClass]="{ 'mobile': isMobile }">
            <div class="profile-picture" [ngClass]="{ 'mobile': isMobile }">
              <img
                [attr.alt]="'header.profilePictureAlt' | translate"
                [class.loading]="!isImageLoaded"
                (load)="onImageLoad()"
                loading="lazy"
                [src]="application?.applicantProfileImageUrl"
              />
            </div>
          </div>
          <div class="applicant-information">
            <div class="user-name">
              {{ application?.applicantName }} &nbsp;
              <span class="status-badge" [ngClass]="{
            'status-application': application?.status === 'PENDING',
            'status-shortlisted': application?.status === 'SHORTLISTED',
            'status-interview': application?.status === 'INVITED_TO_INTERVIEW',
            'status-offered': application?.status === 'OFFERED',
            'status-under-review': application?.status === 'INTERVIEWED',
            'status-hired': application?.status === 'ACCEPTED',
            'status-rejected': application?.status === 'REJECTED'
            }">
            {{ ('applications.status.' + application?.status) | translate }}
          </span>
            </div>
          </div>
        </div>
        <!-- Actions -->
        <div class="name-actions-wrapper">
          <app-application-actions
            *ngIf="application"
            role="company"
            [userId]="application.userId"
            class="header-actions"
            [app]="application"
            [isMobile]="false"
            variant="menu"
          >
          </app-application-actions>
        </div>
      </div>

      <!-- Process Stepper -->
      <div class="stepper-container">
        <!-- If job title is dynamic, pass it as plain text next to translation -->
        <div class="stepper-title">
          {{ 'process.title' | translate }} : {{ jobTitle }}
        </div>

        <div class="stepper-track">
          <div class="step" *ngFor="let step of steps; let i = index">
            <div class="step-dot-wrapper">
              <div class="step-dot" [ngClass]="{
  'done': step.done,
  'active': !step.done && steps[i - 1]?.done
}"></div>
              <div
                class="step-line"
                *ngIf="i < steps.length - 1"
                [ngClass]="{
    'done': step.done && steps[i + 1]?.done,
    'to-active': step.done && !steps[i + 1]?.done
  }"
              ></div>
            </div>
            <div class="step-label" [ngClass]="{ 'done': step.done }">{{ step.label }}</div>
            <div class="step-date" *ngIf="step.date">{{ step.date | date: 'MMM d, y · HH:mm' }}</div>
          </div>
        </div>
      </div>

      <!-- Main Content Layout -->
      <div class="content-layout" fxLayout="row" fxLayoutGap="1.5rem" fxLayout.lt-md="column">
        <!-- Left Panel -->
        <div class="left-panel" fxFlex="65">
          <mat-tab-group [(selectedIndex)]="activeTabIndex" mat-stretch-tabs>
            <mat-tab [label]="'tabs.interviews' | translate">
              <div class="interview-list">
                <mat-card class="interview-card" *ngFor="let interview of interviews">
                  <mat-card-title class="title-container">
                    <div class="title-status">
                      <span class="title">{{ interview.title }}</span>
                      <span class="status"
                            [ngClass]="{
                          'invited':    interview.status === 'INVITED',
                          'upcoming':   interview.status === 'UPCOMING',
                          'finished':   interview.status === 'COMPLETED',
                          'rescheduled': interview.status === 'RESCHEDULED',
                          'cancelled':  interview.status === 'CANCELLED',
                          'declined':   interview.status === 'DECLINED'
                        }">
                        <ng-container [ngSwitch]="interview.status">
                          <ng-container *ngSwitchCase="'INVITED'">{{ 'interviews.status.invited' | translate }}</ng-container>
                          <ng-container *ngSwitchCase="'UPCOMING'">{{ 'interviews.status.upcoming' | translate }}</ng-container>
                          <ng-container *ngSwitchCase="'COMPLETED'">{{ 'interviews.status.completed' | translate }}</ng-container>
                          <ng-container *ngSwitchCase="'RESCHEDULED'">{{ 'interviews.status.rescheduled' | translate }}</ng-container>
                          <ng-container *ngSwitchCase="'CANCELLED'">{{ 'interviews.status.cancelled' | translate }}</ng-container>
                          <ng-container *ngSwitchCase="'DECLINED'">{{ 'interviews.status.declined' | translate }}</ng-container>
                          <ng-container *ngSwitchDefault>{{ interview.status }}</ng-container>
                        </ng-container>
                      </span>
                    </div>

                    <div class="guest-count" *ngIf="interview.guests?.length > 0">
                      {{
                        interview.guests.length === 1
                          ? ('interviews.guests.one' | translate)
                          : ('interviews.guests.many' | translate:{count: interview.guests.length})
                      }}
                    </div>
                  </mat-card-title>

                  <mat-card-subtitle class="interview-info">
                    <mat-icon class="icon">calendar_today</mat-icon>
                    {{ interview.date | date: 'EEE, MMM dd' }} ·
                    <mat-icon class="icon">access_time</mat-icon>
                    <div style="display: flex; justify-content: center;">
                      {{ interview.startTime }} – {{ interview.endTime }}
                      ({{ getDuration(interview.startTime, interview.endTime) }})
                    </div>
                  </mat-card-subtitle>


                  <mat-card-content>
                    <!-- TODO: feedback not yet implemented
                    <div *ngIf="interview.status === 'COMPLETED'" class="feedback">
                      <p><strong>{{ 'interviews.feedback' | translate }}:</strong> 👍 92%</p>
                      <p class="feedback-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit...</p>
                    </div>
                    -->
                  </mat-card-content>

                  <mat-card-actions *ngIf="interview.status === 'UPCOMING'" style="gap: 1rem;">
                    <app-button
                      [label]="'interviews.startMeeting' | translate"
                      (click)="startMeeting(interview.meetingId)"
                      [size]="ButtonSize.MEDIUM"
                      [state]="ButtonState.REGULAR"
                      [type]="ButtonType.PRIMARY"
                    ></app-button>
                    <app-button
                      [label]="'interviews.sendMessage' | translate"
                      (click)="sendMessage()"
                      [size]="ButtonSize.MEDIUM"
                      [state]="ButtonState.REGULAR"
                      [type]="ButtonType.SECONDARY"
                    ></app-button>
                    <app-button
                      [label]="'interviews.cancel' | translate"
                      (click)="cancelMeeting(interview.id)"
                      [size]="ButtonSize.LARGE"
                      [state]="ButtonState.REGULAR"
                      [type]="ButtonType.GHOST"
                    ></app-button>
                  </mat-card-actions>

                  <!-- Reschedule request: confirm or decline -->
                  <mat-card-actions *ngIf="interview.status === 'RESCHEDULED'" style="gap: 1rem; flex-direction: column; align-items: flex-start;">
                    <div class="reschedule-request-info" *ngIf="interview.rescheduleRequest">
                      <strong>Proposed:</strong>
                      {{ interview.rescheduleRequest.date | date:'EEE, MMM dd' }} ·
                      {{ interview.rescheduleRequest.startTime }} – {{ interview.rescheduleRequest.endTime }}
                    </div>
                    <div style="display: flex; gap: 0.75rem;">
                      <app-button
                        [label]="'interviews.confirmReschedule' | translate"
                        (click)="confirmReschedule(interview)"
                        [size]="ButtonSize.MEDIUM"
                        [state]="ButtonState.REGULAR"
                        [type]="ButtonType.PRIMARY"
                      ></app-button>
                      <app-button
                        [label]="'interviews.declineReschedule' | translate"
                        (click)="declineReschedule(interview)"
                        [size]="ButtonSize.MEDIUM"
                        [state]="ButtonState.REGULAR"
                        [type]="ButtonType.GHOST"
                      ></app-button>
                    </div>
                  </mat-card-actions>
                </mat-card>

                <ng-container *ngIf="interviews.length === 0">
                  <p style="color: gray; font-style: italic; margin-top: 1rem;">
                    {{ 'interviews.empty' | translate }}
                  </p>
                </ng-container>
              </div>
            </mat-tab>

            <mat-tab [label]="'tabs.checklist' | translate">
              <div class="checklist-wrapper">
                <mat-card class="checklist-section" *ngIf="visaEval">
                  <div class="section-header" (click)="toggleVisumOpen()">
                    <div class="step-heading">{{ visaEval.process.titleKey | translate }}</div>
                    <div class="progress-container">
                      <mat-progress-bar class="small-progress-bar" mode="determinate"
                                        [value]="visaEval.progressPercent"></mat-progress-bar>
                      <span class="progress-value">{{ visaEval.progressPercent }}%</span>
                      <button mat-icon-button disableRipple>
                        <mat-icon>{{ isVisumOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
                      </button>
                    </div>
                  </div>

                  <mat-divider></mat-divider>

                  <div class="checklist-item" *ngIf="isVisumOpen">
                    <div class="checklist-item" *ngFor="let e of visaEval.items">
                      <div class="left">
                        <mat-checkbox [checked]="e.done" disabled="" color="primary">
                          <div class="label-text">
                            {{ e.item.key | translate: {fallback: e.item.label} }}
                            <div class="meta" *ngIf="e.matchedMaterials.length > 0">
                              <!-- Could show uploader/time if you store it; for now, show titles -->
                              <span *ngFor="let mm of e.matchedMaterials; let i = index">
                                {{ mm.title }}
                                <ng-container *ngIf="i < e.matchedMaterials.length - 1">, </ng-container>
                              </span>
                            </div>
                          </div>
                        </mat-checkbox>
                      </div>

                      <div class="right">
                        <ng-container *ngIf="e.matchedMaterials.length > 0; else uploadSection">
                          <div class="doc-actions">
                            <button class="icon-button" (click)="downloadMaterial(e.matchedMaterials[0])">
                              <img src="assets/download.svg" [alt]="'candidates.download' | translate"/>
                            </button>
                            <button class="icon-button" (click)="previewMaterial(e.matchedMaterials[0])">
                              <img src="assets/view.png" [alt]="'candidates.view' | translate"/>
                            </button>
                            <button class="icon-button" (click)="deleteMaterial(e.matchedMaterials[0])">
                              <img src="assets/garbadge.png" [alt]="'candidates.delete' | translate"/>
                            </button>
                          </div>
                        </ng-container>

                        <ng-template #uploadSection>
                          <app-button
                            (click)="uploadMaterialFor(e.item)"
                            [type]="ButtonType.SECONDARY"
                            [state]="ButtonState.REGULAR"
                            [size]="ButtonSize.MEDIUM"
                            [leftIcon]="'assets/upload-process.png'"
                            [showLeftIcon]="true"
                            [label]="'process.uploadDocument' | translate">
                          </app-button>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </mat-card>

                <mat-card class="checklist-section" *ngIf="docsEval">
                  <div class="section-header" (click)="toggleDocsOpen()">
                    <div class="step-heading">{{ docsEval.process.titleKey | translate }}</div>
                    <div class="progress-container">
                      <mat-progress-bar class="small-progress-bar" mode="determinate"
                                        [value]="docsEval.progressPercent"></mat-progress-bar>
                      <span class="progress-value">{{ docsEval.progressPercent }}%</span>
                      <button mat-icon-button disableRipple>
                        <mat-icon>{{ isDocsOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
                      </button>
                    </div>
                  </div>

                  <mat-divider></mat-divider>

                  <div class="checklist-item" *ngIf="isDocsOpen">
                    <div class="checklist-item" *ngFor="let e of docsEval.items">
                      <div class="left">
                        <mat-checkbox [checked]="e.done" disabled color="primary">
                          <div class="label-text">
                            {{ e.item.key | translate: { fallback: e.item.label } }}
                            <div class="meta" *ngIf="e.matchedMaterials.length > 0">
              <span *ngFor="let mm of e.matchedMaterials; let i = index">
                {{ mm.title }}
                <ng-container *ngIf="i < e.matchedMaterials.length - 1">, </ng-container>
              </span>
                            </div>
                          </div>
                        </mat-checkbox>
                      </div>

                      <div class="right">
                        <ng-container *ngIf="e.matchedMaterials.length > 0; else uploadDocSection">
                          <div class="doc-actions">
                            <button class="icon-button" (click)="downloadMaterial(e.matchedMaterials[0])">
                              <img src="assets/download.svg" [alt]="'candidates.download' | translate"/>
                            </button>
                            <button class="icon-button" (click)="previewMaterial(e.matchedMaterials[0])">
                              <img src="assets/view.png" [alt]="'candidates.view' | translate"/>
                            </button>
                            <button class="icon-button" (click)="deleteMaterial(e.matchedMaterials[0])">
                              <img src="assets/garbadge.png" [alt]="'candidates.delete' | translate"/>
                            </button>
                          </div>
                        </ng-container>

                        <ng-template #uploadDocSection>
                          <app-button
                            (click)="uploadMaterialFor(e.item)"
                            [type]="ButtonType.SECONDARY"
                            [state]="ButtonState.REGULAR"
                            [size]="ButtonSize.MEDIUM"
                            [leftIcon]="'assets/upload-process.png'"
                            [showLeftIcon]="true"
                            [label]="'process.uploadDocument' | translate">
                          </app-button>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </mat-card>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

        <!-- Right Panel -->
        <div fxFlex="35" class="side-panel">
          <mat-card class="personal-info-card">
            <div style="display: flex; padding-left: 0.6rem; padding-bottom: 1rem;">
              <div>
                <img style="width: 1.5rem; height: 1.5rem;" [src]="'assets/personal-info.png'">
              </div>
              <mat-card-title class="personal-info">
                &nbsp;{{ 'rightPanel.personalInfoTitle' | translate }}
              </mat-card-title>
            </div>

            <mat-card-content>
              <div class="language-info">
                <div class="languages">{{ 'rightPanel.language' | translate }}</div>
                <div class="languages-line">
                  <ng-container *ngFor="let lang of user?.languages">
    <span class="language-chip">
      <img [src]="getFlagSrc(lang)" class="flag-icon">
      <span class="language-name">{{ lang }}</span>
    </span>
                  </ng-container>
                </div>

              </div>

              <div class="section">
                <h4>{{ 'rightPanel.education' | translate }}</h4>
                <ng-container *ngIf="lastEducation">
                  <div class="education-entry">
                    <div style="display: flex; gap: 0.5rem">
                      <div>
                        <img style="width: 1rem; height: 1rem; padding-top: 1rem;" [src]="'assets/building.png'">
                      </div>
                      <div>
                        <h5>{{ lastEducation.location }}</h5>
                        <h5>{{ lastEducation.education }}</h5>
                        <h6>
                          {{ lastEducation.startDate | date: 'MM/yyyy' }} -
                          {{ lastEducation.completionDate | date: 'MM/yyyy' }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>

              <div class="section">
                <h4>{{ 'rightPanel.experience' | translate }}</h4>
                <ng-container *ngIf="lastExperience">
                  <div class="experience-entry">
                    <div style="display: flex; gap: 0.5rem">
                      <div>
                        <img style="width: 1rem; height: 1rem; padding-top: 1rem;" [src]="'assets/building.png'">
                      </div>
                      <div>
                        <h5>{{ lastExperience.location }}</h5>
                        <h5>{{ lastExperience.jobTitle }}</h5>
                        <h6>
                          {{ lastExperience.startDate | date: 'MM/yyyy' }} -
                          {{ lastExperience.completionDate | date: 'MM/yyyy' }}
                        </h6>
                        <div *ngFor="let bullet of (lastExperience.jobDescription?.split('\n') || [])">
                          {{ bullet }}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="personal-info-card notes-wrapper">
            <div class="notes-header">
              <div style="display: flex; padding-left: 0.6rem; padding-bottom: 1rem; padding-top: 1rem">
                <div>
                  <img style="width: 1.5rem; height: 1.5rem;" [src]="'assets/notes.png'">
                </div>
                <mat-card-title class="personal-info">
                  &nbsp;{{ 'notes.title' | translate }}
                </mat-card-title>
              </div>

              <app-button
                [isFullWidth]="true"
                (click)="openAddNoteModal()"
                [leftIcon]="'assets/add-notes.png'"
                [showLeftIcon]="true"
                [label]="'notes.add' | translate"
                [size]="ButtonSize.SMALL"
                [state]="ButtonState.REGULAR"
                [type]="ButtonType.SECONDARY"
              ></app-button>
            </div>

            <ng-container *ngIf="notes?.length > 0; else noNotes">
              <div class="note-card" *ngFor="let note of notes">
                <div class="note-header">
                  <div class="note-title">{{ note.title }}</div>
                  <div class="note-actions">
                    <img
                      class="edit-icon"
                      src="assets/icons/edit.png"
                      [attr.alt]="'notes.editAlt' | translate"
                      (click)="openEditNoteModal(note)"
                    />
                    <img
                      class="certif-icon"
                      src="assets/icons/delete.png"
                      [attr.alt]="'notes.deleteAlt' | translate"
                      (click)="deleteNote(note.id)"
                    />
                  </div>
                </div>

                <div class="note-meta">
                  <span class="meta-item">
                    <mat-icon class="icon">calendar_today</mat-icon>
                    <div style="display: flex; justify-content: center;">
                      {{ note.createdAt | date: 'fullDate' }}
                    </div>
                  </span>
                  <span class="meta-item">
                    <mat-icon class="icon">access_time</mat-icon>
                    <div style="display: flex; justify-content: center;">
                      {{ note.createdAt | date: 'shortTime' }}
                    </div>
                  </span>
                </div>

                <div class="note-body">{{ note.content }}</div>
              </div>
            </ng-container>

            <ng-template #noNotes>
              <p style="color: gray; font-style: italic;">
                {{ 'notes.empty' | translate }}
              </p>
            </ng-template>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div class="footer-class footer-container">
  <app-footer></app-footer>
</div>

<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
